import React from "react";
import { Store, X } from "lucide-react";

export const computeSalesOpen = (s) => {
  if (s.sales_open === false) return false;
  const today = new Date().toISOString().slice(0, 10);
  if (s.sales_start && today < s.sales_start) return false;
  if (s.sales_end && today > s.sales_end) return false;
  return true;
};

export const modeFromSettings = (s) => {
  if (s.sales_open === false) return "always_closed";
  return s.sales_start || s.sales_end ? "by_date" : "always_open";
};

export const applyMode = (s, mode, start, end) => {
  if (mode === "always_open") return { ...s, sales_open: true, sales_start: "", sales_end: "" };
  if (mode === "always_closed") return { ...s, sales_open: false, sales_start: "", sales_end: "" };
  return { ...s, sales_open: true, sales_start: start, sales_end: end };
};

const MODES = [
  ["always_open", "مفتوح دائماً للبيع"],
  ["always_closed", "مغلق دائماً (ما أحد يقدر يطلب)"],
  ["by_date", "مفتوح بين تاريخين"],
];

const DateField = ({ label, value, onChange, testId }) => (
  <div>
    <label className="text-[10px] text-[#8A857D]">{label}</label>
    <input type="date" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="w-full bg-[#0B0A08] border border-[#2A2824] text-[#F2EBE1] text-xs p-2 mt-1" />
  </div>
);

export const SalesPanel = ({ isOpenNow, mode, setMode, start, setStart, end, setEnd, loading, onSave, onClose }) => (
  <div data-testid="admin-sales-panel" dir="rtl" className="fixed bottom-24 start-6 z-[60] w-[320px] bg-[#141311] border border-[#2A2824] p-6 shadow-2xl">
    <div className="flex items-center justify-between mb-1">
      <p className="text-sm text-[#F2EBE1] tracking-wide flex items-center gap-2"><Store size={16} className="text-[#C49A6C]" /> التحكم ببيع العطر</p>
      <button onClick={onClose} data-testid="admin-sales-close"><X size={16} className="text-[#8A857D]" /></button>
    </div>
    <p className={`text-[11px] mb-4 ${isOpenNow ? "text-[#9ec49a]" : "text-[#d79a9a]"}`}>الحالة الآن: {isOpenNow ? "البيع مفتوح" : "البيع مغلق"}</p>
    <div className="space-y-2.5 text-sm">
      {MODES.map(([v, l]) => (
        <label key={v} className="flex items-center gap-2 cursor-pointer text-[#D4C3B3]">
          <input type="radio" name="salesmode" checked={mode === v} onChange={() => setMode(v)} data-testid={`sales-mode-${v}`} className="accent-[#C49A6C]" />
          <span>{l}</span>
        </label>
      ))}
    </div>
    {mode === "by_date" && (
      <div className="grid grid-cols-2 gap-3 mt-4">
        <DateField label="من تاريخ" value={start} onChange={setStart} testId="sales-fab-start" />
        <DateField label="إلى تاريخ" value={end} onChange={setEnd} testId="sales-fab-end" />
      </div>
    )}
    <button onClick={onSave} disabled={loading} data-testid="sales-fab-save" className="w-full bg-[#C49A6C] text-[#0B0A08] text-sm font-semibold uppercase tracking-[0.2em] py-3 mt-5 hover:bg-[#E7CBA9] transition-colors disabled:opacity-50">
      {loading ? "جارٍ الحفظ…" : "حفظ"}
    </button>
  </div>
);
